import {
    types
} from './types';
import firebase from '../firebase/firebase';

const db = firebase.database();

export const notifyUser = (options) => async dispatch => {
    return new Promise(function (resolve, reject) {
        // console.log('SENDING NOTIFICATION');
        dispatch({
            type: types.NOTIFICATION_SENT,
            payload: {
                ...options,
                visible: true
            }
        });

        // CLOSE DIALOG AFTER SPECIFIED DURATION OR DEFAULT
        setTimeout(() => {
            dispatch({
                type: types.HIDE_NOTIFICATION,
                payload: false
            })
        }, options.duration || 3000);

        resolve(true);
    });
};

export const getNewMessageCount = (uid) => async dispatch => {
    const messagesNotificationRef = db.ref(`clients/${uid}/notifications`);
    messagesNotificationRef.off();

    messagesNotificationRef.on('value', snap => {
        console.log('notify snap', snap.val());
        db.ref(`notifications`).orderByChild('receiverId').equalTo(uid).once('value', notificationSnap => {
            console.log('notification objects', notificationSnap.val());
            // THIS IS NOT DOING ANYTHING, DELETE?
        }, e => {
            console.log('FIREBASE ERROR:', e)
        });
    }, e => console.log)
}

const sortNotification = (notification, notificationArrays, senderId, serviceId) => {
    //     const updatedNotificationArrays = {...notificationArrays};
    //     // console.log('Notification to be sorted:', notification);
    //     // console.log('Sender/Service', senderId, '/', serviceId);

    //     if (notification.type === 'newMessage') {
    //         updatedNotificationArrays.newChatMessages.push(notification);
    //     }
    //     if (notification.type === 'newNutritionLog') {
    //         updatedNotificationArrays.newNutritionLogs.push(notification);
    //     }
    //     if (notification.type === 'newNutritionLogReview') {
    //         updatedNotificationArrays.newNutritionLogReviews.push(notification);
    //     }
    //     if (notification.type === 'newNutritionLogLike') {
    //         updatedNotificationArrays.newNutritionLogLikes.push(notification);
    //     }
    //     if (notification.type === 'newNutritionLogComment') {
    //         updatedNotificationArrays.newNutritionLogComments.push(notification);
    //     }
    //     if (notification.type === 'newBooking') {
    //         updatedNotificationArrays.newBookings.push(notification);
    //     }
    //     if (notification.type === 'newExpertContent') {
    //         updatedNotificationArrays.newExpertContent.push(notification);
    //     }
    //     // console.log('SORTED NOTIFICATIONS', updatedNotificationArrays);
    //     return updatedNotificationArrays;
}

const dispatchNotifications = (notifications, dispatch) => {
    //     if (notifications) {
    //         if (notifications.newChatMessages && notifications.newChatMessages.length > 0 ) {
    //             console.log('NEW CHAT MESSAGES @ ACTION DISPATCH', notifications.newChatMessages);
    //             dispatch({
    //                 type: types.GET_NEW_CHAT_NOTIFICATION_SUCCESS,
    //                 payload: uniq(notifications.newChatMessages)
    //             })
    //         }
    //         if (notifications.newNutritionLogs && notifications.newNutritionLogs.length > 0 ) {
    //             console.log('NEW NL @ ACTION DISPATCH', notifications.newNutritionLogs);
    //             dispatch({
    //                 type: types.GET_NEW_NUTRITION_LOG_NOTIFICATION_SUCCESS,
    //                 payload: notifications.newNutritionLogs
    //             })
    //         }
    //         if (notifications.newNutritionLogLikes && notifications.newNutritionLogLikes.length > 0 ) {
    //             console.log('NEW NL LIKES @ ACTION DISPATCH', notifications.newNutritionLogLikes);
    //             dispatch({
    //                 type: types.GET_NEW_NUTRITION_LOG_LIKES_NOTIFICATION_SUCCESS,
    //                 payload: notifications.newNutritionLogLikes
    //             })
    //         }
    //         if (notifications.newNutritionLogReviews && notifications.newNutritionLogReviews.length > 0 ) {
    //             console.log('NEW NL REVIEWS @ ACTION DISPATCH', notifications.newNutritionLogReviews);
    //             dispatch({
    //                 type: types.GET_NEW_NUTRITION_LOG_REVIEWS_NOTIFICATION_SUCCESS,
    //                 payload: notifications.newNutritionLogReviews
    //             })
    //         }
    //         if (notifications.newNutritionLogComments && notifications.newNutritionLogComments.length > 0 ) {
    //             console.log('NEW NL COMMENTS @ ACTION DISPATCH', notifications.newNutritionLogComments);
    //             dispatch({
    //                 type: types.GET_NEW_NUTRITION_LOG_COMMENTS_NOTIFICATION_SUCCESS,
    //                 payload: notifications.newNutritionLogComments
    //             })
    //         }
    //         if (notifications.newBookings && notifications.newBookings.length > 0 ) {
    //             console.log('NEW BOOKING @ ACTION DISPATCH', notifications.newBookings);
    //             dispatch({
    //                 type: types.GET_NEW_BOOKINGS_NOTIFICATION_SUCCESS,
    //                 payload: notifications.newBookings
    //             })
    //         }
    //         if (notifications.newExpertContent && notifications.newExpertContent.length > 0 ) {
    //             console.log('NEW EXPERT CONTENT @ ACTION DISPATCH', notifications.newExpertContent);

    //             dispatch({
    //                 type: types.GET_NEW_EXPERT_CONTENT_NOTIFICATION_SUCCESS,
    //                 payload: notifications.newExpertContent
    //             })
    //         }
    //     }
}

export const getNotificationCounts = ({
    userId,
    senderId,
    serviceId
}) => async dispatch => {
    //     // dispatch(refreshNotifications());
    //     const notificationsPerUserRef = db.ref(`notifications/${userId}`)
    //     notificationsPerUserRef.off();
    //     let initialDataLoaded;
    //     console.log('GETTING NOTIFICATIONS COUNTS');
    //     return new Promise((resolve, reject) => {
    //         // handleNewNotifications must be nested so it will read initialDataLoaded from parent scope
    //         const handleNewNotifications = (snap, dispatch, type) => {
    //             if (snap.val()) {
    //                 let notificationArrays = {
    //                     newChatMessages: [],
    //                     newNutritionLogs: [],
    //                     newNutritionLogComments: [],
    //                     newNutritionLogReviews: [],
    //                     newNutritionLogLikes: [],
    //                     newExpertContent: [],
    //                     newBookings: [],
    //                 }
    //                 let updatedNotificationArrays;

    //                 if (type === 'initial') {
    //                     // console.log('GETTING INITIAL NOTIFICATIONS');
    //                     snap.forEach(notificationSnap => {
    //                         if (notificationSnap) {
    //                             const notification = notificationSnap.val();
    //                             // console.log('NEW NOTIFICATION (INITIAL)', notification);
    //                             if ((!notification.read || notification.read === 'false') && notification.params.senderId === senderId && notification.params.serviceId === serviceId) {
    //                                 updatedNotificationArrays = sortNotification(notification, notificationArrays, senderId, serviceId);
    //                             }
    //                         }
    //                     });
    //                     initialDataLoaded = true;
    //                     // console.log('GOT NEW NOTIFICATIONS', snap.val());
    //                     if (updatedNotificationArrays) console.log('GOT ALL NEW NOTIFICATIONS', updatedNotificationArrays);
    //                 }

    //                 if (type === 'new') {
    //                     if (initialDataLoaded){
    //                         console.log('NEW NOTIFICATION JUST ARRIVED');
    //                         const notification = snap.val();
    //                         updatedNotificationArrays = sortNotification(notification, notificationArrays);
    //                     }
    //                 }
    //                 if (updatedNotificationArrays) {
    //                     // console.log('updatedNotificationArrays', updatedNotificationArrays);
    //                     dispatchNotifications(updatedNotificationArrays, dispatch);
    //                 }
    //                 resolve();
    //             }
    //         }

    //         notificationsPerUserRef.once('value', 
    //             (snap) => { 
    //                 // SUCCESS CALLBACK
    //                 dispatch(refreshNotifications());
    //                 handleNewNotifications(snap, dispatch, 'initial');
    //             }, 
    //             (e)=>{
    //                 // ERROR CALLBACK
    //                 console.log('GETTING NOTIFICATIONS FAILED', e);
    //             })
    //             .then(() => {
    //                 console.log('DONE GETTING NOTIFICATIONS');
    //             })
    //             .catch(console.log);

    //         notificationsPerUserRef.on('child_added', (snap) => { handleNewNotifications(snap, dispatch, 'new') });
    //     });
}

export const refreshNotifications = () => {
    return {
        type: types.CLEAR_NOTIFICATIONS
    }
}

export const clearNotifications = ({
    type,
    userId,
    serviceId,
    clientId
}) => async dispatch => {
    return new Promise((resolve, reject) => {
        // console.log('CLEARING NOTIFICATIONS...', type);
        let senderId;
        // let serviceId;

        if (type === 'newExpertContent' || type === 'newMessage' || type === 'newNutritionLog' || type === 'newNutritionLogLike' || type === 'newNutritionLogComment' || type === 'newNutritionLogReview' || type === 'newBooking') {
            const notificationQuery = db.ref(`notifications/${userId}`).orderByChild('type').equalTo(type);
            notificationQuery.once('value', snap => {

                // set notifications as seen = true
                snap.forEach(notificationSnap => {
                    const notification = notificationSnap.val();
                    if ((notification.read === 'false' || !notification.read) && notification.params.receiverId !== userId && notification.type === type && notification.params.serviceId === serviceId && clientId ? notification.params.senderId === clientId : true) {
                        // console.log('NOTIFICATIONS TO MARK AS SEEN', snap.val());
                        const notificationKey = notificationSnap.key;
                        db.ref(`notifications/${userId}/${notificationKey}/read`).set('true');
                        senderId = notification.params.senderId;
                        // console.log('SENDER', senderId, notification.params);
                    } else {
                        console.log('Notification is not going to be marked as read', notification);
                    }
                });
                // REFRESH THE NOTIFICATIONS AFTER REMOVING ONES THAT HAVE BEEN READ
                // console.log('SENDER/SERVICE', senderId,'/', serviceId);
                resolve('Successfully cleared notifications');
            }, (e) => {
                resolve(e)
                console.log('FIREBASE ERROR WHILE ATTEMPTING CLEARING NOTIFICATIONS', e);
            });
        }
    });
}

export const initializeCloudMessaging = (user) => (dispatch, state) => {
    // SETUP MESSAGING
    const messaging = firebase.messaging();
    messaging.requestPermission()
        .then(() => {
            console.log('PUSH NOTIFICATIONS ALLOWED BY USER');
            const fcmToken = localStorage.getItem('fcmToken');
            if (!fcmToken) return messaging.getToken();
            console.log('fcmToken', fcmToken);
        })
        .then(token => {
            if (token) {
                // dispatch({
                //     type: types.GET_FCM_TOKEN_SUCCESS,
                //     payload: fcmToken
                // })
                console.log('WE HAVE A TOKEN:', token);
                localStorage.setItem('fcmToken', token);

                const userDeviceTokenRef = firebase.database().ref(`/clients/${user.uid}/deviceTokens`);
                userDeviceTokenRef.once('value', snap => {
                    const tokensObject = snap.val();
                    console.log('tokenObject.val()', tokenObject.val());

                    if (!Object.values(tokensObject).includes(token)) {
                        // THERE IS NO TOKEN FOR THIS DEVICE YET
                        console.log('NO TOKEN FOR THIS DEVICE YET, ADDING ONE NOW...');

                        const key = userDeviceTokenRef.push().key;
                        console.log('KEY', key);
                        return userDeviceTokenRef.child(key).set(token)
                            .then(() => {
                                console.log('TOKEN SENT TO DB');
                            })
                            .catch(e => {
                                console.log('COULD NOT SEND TOKEN TO DB', e);
                            });
                    }
                    // THERE IS ALREADY A TOKEN FOR THIS DEVICE
                    return null;
                }, e => {
                    console.log('FIREBASE ERROR:', e)
                })
            }
        })
        .catch(e => {
            console.log('USER HAS REJECTED MESSAGING', e);
            // alert('Note: You can always change your mind next time you visit but, as requested, you will not receive any push notifications.');
        })
    messaging.onMessage((payload) => {
        console.log('onMessage', payload);
    })
}

// THIS IS INTENDED TO RESET UNREAD COUNTS ONCE LEAVING THE CURRENT SERVICE SELECTION 
export const resetUnreadCounts = () => {
    console.log('RESETTING UNREAD COUNTS');
    return {
        type: types.RESET_TOTAL_UNREAD_COUNT
    }
}

export const checkUnreadsForServiceConsumerPair = async (userId, consumerUid, serviceId) => async dispatch => {
    // console.log('CHECKING UNREADS FOR SERVICE', serviceId, consumerUid);
    await checkUnreadsCountBySenderOrService({
        userId,
        id: serviceId,
        dispatch,
        type: 'serviceId',
        consumerUid
    });
}

export const checkUnreadsForService = async (userId, consumerUid, serviceId) => async dispatch => {
    // console.log('CHECKING UNREADS FOR SERVICE', serviceId, consumerUid);
    await checkUnreadsCountBySenderOrService({
        userId,
        id: serviceId,
        dispatch,
        type: 'serviceId'
    });
}


export const checkUnreadsForUserClient = async (userId, clientUid) => async dispatch => {
    // console.log('CHECKING UNREADS FOR CLIENT', clientUid);
    await checkUnreadsCountBySenderOrService({
        userId,
        id: clientUid,
        dispatch,
        type: 'senderId'
    });
}

const checkUnreadsCountBySenderOrService = async ({
    userId,
    id,
    dispatch,
    type,
    consumerUid
}) => {
    try {
        // console.log('CHECKING UNREADS FOR', id, type);

        let counts = {
            count: 0,
            newBookingCount: 0,
            newChatMessageCount: 0,
            newNutritionLogCount: 0,
            newNutritionLogReviewCount: 0,
            newNutritionLogCommentCount: 0,
            newNutritionLogLikeCount: 0,
            newExpertContentCount: 0,
        }

        let doneLoadingInitial = false;

        const notificationsRef = db.ref(`notifications/${userId}`);
        // const notificationsQuery = notificationsRef.orderByChild('read').equalTo('false');

        notificationsRef.off('child_added', handleNewNotification); // THIS IS REQUUIRED BUT BREAKS ASYNC AWAIT - RISK FOR MEMORY LEAKS WITHOUT THIS
        notificationsRef.off('child_changed', handleChangedNotification); // THIS IS REQUUIRED BUT BREAKS ASYNC AWAIT - RISK FOR MEMORY LEAKS WITHOUT THIS

        // HANDLES NEW NOTIFICATION COUNT UPDATES
        notificationsRef.on('child_added', handleNewNotification, e => console.log)

        // HANDLES CASE WHERE THE NOTIFICATION COUNTS CHANGE BECAUSE SOMETHING IS MARKED AS READ
        notificationsRef.on('child_changed', handleChangedNotification, e => console.log)

        // console.log('UNREADS BEFORE AWAIT');

        // HANDLE INITIAL LOADING OF NOTIFICATION DATA (THIS ONLY RUNS AFTER THE ON CALLS FINISH GOING OVER EACH OF THE EXISTING NOTIFICATONS FOR THE LOGGED USER) 
        let newNotificationsSnap = await notificationsRef.once('value');
        // console.log('UNREADS AFTER AWAIT', newNotificationsSnap.val(), id);

        const finishedLoadingUserNotifications = !!newNotificationsSnap.val();
        if (finishedLoadingUserNotifications) {
            newNotificationsSnap.forEach(snap => {
                // GO OVER EACH USER NOTIFICATION TO SEE WHICH ARE UNREAD AND TO DISPATCH CONTECT SPECIFIC UNREAD COUNTS
                detectNotificationContextAndStatus(snap.val(), type, id, counts, dispatch, consumerUid, false);
            })

            doneLoadingInitial = true;
        }

        function handleChangedNotification(snap) {
            console.log(`%cA NOTIFICATION HAS CHANGED`, 'color:greenyellow');
            detectNotificationContextAndStatus(snap.val(), type, id, counts, dispatch, consumerUid, true);
        }

        function handleNewNotification(snap) {
            if (doneLoadingInitial) detectNotificationContextAndStatus(snap.val(), type, id, counts, dispatch, consumerUid, false);
        }
    } catch (e) {
        console.log('ERROR:', e)
    }
}

const detectNotificationContextAndStatus = (newOrChangedNotification, type, id, counts, dispatch, consumerUid, change) => {
    // THIS FUNCTION RUNS FOR EACH NOTIFICATION AND VERIFIES IF NEW AND IF THE SERVICE IS KNOWN OR NOT

    // console.log('NOTIFICATION CONTEXT: ', type, id, consumerUid);
    // console.log('NOTIFICATION STATUS: ', newNotification.read);
    // console.log('DETECTING NOTIFICATION CONTEXT...');
    // ADD TO UNREAD COUNT IF THE SERVICE FOR THE SELECTED CONSUMER HAS ANY UNREAD NOTIFICATIONS
    if (type === 'serviceId' && consumerUid && newOrChangedNotification.params['senderId'] === consumerUid && newOrChangedNotification.read === 'false') {
        // console.log('GETTING UNREAD COUNTS FOR CLIENT AND SERVICE PAIR');
        dispatchNewOrChangedNotificationCounts({
            counts,
            notification: newOrChangedNotification,
            id,
            dispatch,
            change
        });
    }

    // IF A SERVICE IS NOT SELECTED THEN JUST FIND UNREADS FOR THE SENDER ID PROVIDED
    if (!consumerUid && newOrChangedNotification.params[type] === id && newOrChangedNotification.read === 'false') {
        // console.log('GETTING UNREAD COUNT FOR CONSUMER OR SERVICE ONLY.');
        dispatchNewOrChangedNotificationCounts({
            counts,
            notification: newOrChangedNotification,
            id,
            dispatch,
            change
        });
    }

    if (change) {
        dispatchNewOrChangedNotificationCounts({
            counts,
            notification: newOrChangedNotification,
            id,
            dispatch,
            change
        });
    }

    return;
}

const dispatchNewOrChangedNotificationCounts = ({
    counts,
    notification,
    id,
    dispatch,
    change
}) => {

    // console.log('NEW NOTIFICATION HAS ARRIVED @ checkUnreads', notification);
    change ? console.log('NOTIFICATION IS NEW') : console.log('NOTIFICATION HAS BEEN VIEWED');
    // CALCULATE NEW NOTIFICATIONS BY TYPE
    if (notification.type === 'newBooking') {
        counts.newBookingCount = change ? 0 : counts.newBookingCount + 1;
    }
    if (notification.type === 'newMessage') {
        counts.newChatMessageCount = change ? 0 : counts.newChatMessageCount + 1;
    }
    if (notification.type === 'newNutritionLog') {
        counts.newNutritionLogCount = change ? 0 : counts.newNutritionLogCount + 1;
    }
    if (notification.type === 'newNutritionLogReview') {
        counts.newNutritionLogReviewCount = change ? 0 : counts.newNutritionLogReviewCount + 1;
    }
    if (notification.type === 'newNutritionLogComment') {
        counts.newNutritionLogCommentCount = change ? 0 : counts.newNutritionLogCommentCount + 1;
    }
    if (notification.type === 'newNutritionLogLike') {
        counts.newNutritionLogLikeCount = change ? 0 : counts.newNutritionLogLikeCount + 1;
    }
    if (notification.type === 'newExpertContent') {
        counts.newExpertContentCount = change ? 0 : counts.newExpertContentCount + 1;
    }

    // CALCULTATE TOTAL NEW NOTIFICATIONS
    counts.count = counts.newBookingCount + counts.newChatMessageCount + counts.newNutritionLogCount + counts.newNutritionLogReviewCount + counts.newNutritionLogCommentCount + counts.newNutritionLogLikeCount + counts.newExpertContentCount;

    // DISPATCH UNREAD NOTIFICATION COUNTS
    dispatch({
        type: types.GET_TOTAL_UNREAD_COUNT,
        payload: {
            [id]: {
                count: counts.count,
                newBookingCount: counts.newBookingCount,
                newChatMessageCount: counts.newChatMessageCount,
                newNutritionLogCount: counts.newNutritionLogCount,
                newNutritionLogReviewCount: counts.newNutritionLogReviewCount,
                newNutritionLogCommentCount: counts.newNutritionLogCommentCount,
                newNutritionLogLikeCount: counts.newNutritionLogLikeCount,
                newExpertContentCount: counts.newExpertContentCount,
            }
        },
        id: id,
    });
}


// WEBPACK FOOTER //
// ./src/js/actions/notification-actions.js